<template>
  <div class="collect-item-row clearfix">
    <div class="collect-item-r-l">
      <a-form-item class="icon-item">
        <i
          class="icon iconfont iconicon-test72"
        />
      </a-form-item>
      <a-form-item class="input-item">
        <a-input
          v-decorator="decorator"
          :disabled="!itemData.ischangename"
          :whitespace="true"
          :placeholder="enterPlaceholder"
          class="collect-input"
          @change="handlerInput"
          @blur="blurInput"
        />
      </a-form-item>
      <select-type
        :item-data="itemData"
        :parent-index="parentIndex"
        :index="index"
        :dis="disable"
        :parent-fieldkey="parentFieldkey"
      />
    </div>
    <div class="collect-item-r-r">
      <a-checkbox
        :default-checked="!!itemData.isenable"
        :disabled="!itemData.ischangeenable"
        @change="enableChange"
      >
        <!-- 启用 -->
        {{ $t('message["728"]') }}
      </a-checkbox>
      <a-checkbox
        :checked="!!itemData.isneeded"
        :disabled="!itemData.ischangeneeded || !itemData.isenable"
        @change="needChange"
      >
        <!-- 必填 -->
        {{ $t('message["33"]') }}
      </a-checkbox>
      <a
        v-if="!!itemData.enabledelete"
        href="javascript:;"
        @click="remove(index)"
      >
        <!-- 删除 -->
        {{ $t('message["962"]') }}
      </a>
    </div>
  </div>
</template>
<script>
import SelectType from './SelectType'
import { mapState, mapMutations } from 'vuex'
import { getLang } from '@/lib//storage'
export default {
  components: {
    SelectType
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {
        }
      }
    },
    parentIndex: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    parentFieldkey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      decorator: [
        `input_${this.parentIndex}_${this.itemData.id || this.itemData._id}`,
        {
          validateTrigger: ['change', 'blur'],
          rules: [{ required: true, message: this.$t('message["67"]') }, { max: 30, message: this.$t('message["68"]') }, { validator: this.isNameRe }],
          initialValue: this.itemData.fieldname
        }
      ],
      disable: false
    }
  },
  computed: {
    ...mapState('config/collect', ['datas']),
    noEmpty () {
      return this.$t('message["67"]')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    maxLen () {
      return this.getLang() === 'en' ? 30 : 10
    }
  },
  inject: ['myForm'],
  methods: {
    ...mapMutations('config/collect', ['setBtnDisable']),
    getLang,
    remove (index) {
      this.$emit('del', index)
    },
    enableChange (item) {
      if (item.target.checked) {
        this.itemData.isenable = 1
        this.disable = false
      } else {
        this.itemData.isenable = 0
        this.itemData.isneeded = 0
        this.disable = true
      }
    },
    needChange (e) {
      if (e.target.checked) {
        this.itemData.isneeded = 1
      } else {
        this.itemData.isneeded = 0
      }
    },
    handlerInput (e) {
      const val = (e.target.value).trim()
      this.itemData.fieldname = val
      this.myForm.form.setFieldsValue({
        [`input_${this.parentIndex}_${this.itemData.id || this.itemData._id}`]: val
      })
      this.myForm.form.validateFields({ force: true }, (errors, values) => {
      })
    },
    blurInput (e) {
      // const val = (e.target.value).trim()
      // this.itemData.fieldname = val
      // this.myForm.form.setFieldsValue({
      //   [`input_${this.parentIndex}_${this.itemData.id || this.itemData._id}`]: val
      // })
      // this.myForm.form.validateFields({ force: true }, (errors, values) => {
      // })
    },
    isNameRe (rule, value, callback) {
      const arr = this.childDatas(this.datas)
      const len = arr.filter((item, index) => item.fieldname === value).length
      if (value && len > 1) {
        this.setBtnDisable(true)
        callback(new Error(this.$t('message["69"]')))
      } else {
        this.setBtnDisable(false)
        callback()
      }
    },
    childDatas (datas) {
      let arr = []
      datas.forEach((item, index) => {
        if (item.child && item.child.length) {
          arr.push(...item.child)
        }
      })
      return arr
    }
  }
}
</script>
<style lang="scss" scoped>
.collect-item-row::v-deep {
  margin-bottom: 24px;
  .icon-item {
    margin-right: 10px;
  }
  .input-item {
    margin-right: 24px;
  }
  .iconicon-test72 {
    font-size: 22px;
    cursor: move;
    color: #ccc;
  }
  .ant-form-item-control {
    line-height: 32px;
  }
  .collect-input {
    width: 240px;
  }
  .collect-item-r-l {
    float: left;
  }
  .collect-item-r-r {
    float: right;
    min-width: 190px;
    text-align: left;
    ::v-deep .ant-checkbox-wrapper {
      margin-right: 24px;
      &.last-child {
        margin-right: 0;;
      }
    }
    .ant-checkbox-wrapper + span, .ant-checkbox + span {
      padding:0 0 0 2px;
    }
  }
}
</style>
